module.exports = __webpack_public_path__ + "img/9815390.f0ff6407.png";